// theme.js
const theme = {
  colors: {
    background: '#1e2124',
    text: '#ffffff',
    primary: '#FFA07A',  // Orange
    secondary: '#4682B4', // Blue
    border: 'rgba(255, 255, 255, 0.1)'
  },
  fontFamily: "'Varela Round', sans-serif",
  borderRadius: {
    small: '6px',
    medium: '8px',
    large: '12px',
    circle: '50%'
  },
  spacing: {
    small: '10px',
    medium: '20px',
    large: '40px'
  },
  fontSize: {
    small: '14px',
    regular: '16px',
    medium: '22px',
    large: '24px',
    xlarge: '32px'
  }
};

export default theme;